import { ProjectVisitGeocodedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import {
  GEOCODE_PENDING_MSG_KEY,
} from '../../../../notifications/geocode';
import { transformUploadedOrdersToPlanningAction } from '../../utils/transformVisitsAddedToPlanningAction';

export default ({ store, remaining }: ProjectVisitGeocodedDtoModelType) => {
  const rootStore = getAppRoot(store);

  if (remaining === 0) {
    getAppEnv(store).closeMessage(GEOCODE_PENDING_MSG_KEY);
  }

  // Return a next callback to be invoked after all the handlers
  return async () => {
    if (remaining === 0) {
      if (rootStore.ui.showUnscheduledVisits && rootStore.ui.selectedWorkspace?.id != null) {
        await rootStore.model.fetchUnscheduledVisitsLatLngs(rootStore.ui.selectedWorkspace?.id);
        rootStore.planningActions.setMapBoundsBasedOnAction(transformUploadedOrdersToPlanningAction());
      }
    }

    if (remaining != null) {
      rootStore.ui.selectedWorkspace?.setVisitGeocodingCount(remaining);
    }

  };
};
